import { Dispatch, SetStateAction } from 'react';

import { useGiftCardContext } from '../../state/gift-card';
import { GiftCardActionSheet } from '../gift-cards-action-sheet';
import { CloseConfirmationModal } from '../gift-cards-action-sheet/close-confirmation-modal';
import { Step } from '../gift-cards-action-sheet/types';

type CheckoutGiftCardActionSheetProps = {
  onGiftCardSaved: () => void;
  // Action sheet state
  isVisible: boolean;
  onClose: () => void;
  headerTitle: string;
  currentStep: Step;
  setCurrentStep: Dispatch<SetStateAction<Step>>;
  // Form state
  cardId: string;
  onCardIdChange: (cardId: string) => void;
  pin: string;
  onPinChange: (pin: string) => void;
  // Confirmation modal state
  closeConfirmationOpen: boolean;
  onConfirmStay: () => void;
  onConfirmLeave: () => void;
};

export function CheckoutGiftCardActionSheet({
  onGiftCardSaved,
  isVisible,
  onClose,
  headerTitle,
  currentStep,
  setCurrentStep,
  cardId,
  onCardIdChange,
  pin,
  onPinChange,
  closeConfirmationOpen,
  onConfirmStay,
  onConfirmLeave,
}: CheckoutGiftCardActionSheetProps) {
  const { currentBalance, handleBalanceUpdate, handleError } = useGiftCardContext();

  return (
    <>
      <GiftCardActionSheet
        headerTitle={headerTitle}
        isVisible={isVisible}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onClose={onClose}
        onGiftCardSaved={onGiftCardSaved}
        cardId={cardId}
        onCardIdChange={onCardIdChange}
        pin={pin}
        onPinChange={onPinChange}
        currentDigitalBalance={currentBalance}
        handleBalanceUpdate={handleBalanceUpdate}
        handleError={handleError}
      />
      {/* Confirmation modal rendered at parent level to avoid nested Modal issue on iOS */}
      <CloseConfirmationModal
        isOpen={closeConfirmationOpen}
        onConfirm={onConfirmStay}
        onDismiss={onConfirmLeave}
      />
    </>
  );
}
